module.exports = __webpack_public_path__ + "img/afiliate-null.dd75d3c9.svg";